/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { BandoTransazioniSelectDTO } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { NegozioPosDTO } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelTransazioneVoucherListItemDTO } from '../model/models';
import { TransazioneVoucherArticoliBatchForm } from '../model/models';
import { TransazioneVoucherArticoloSpendForm } from '../model/models';
import { TransazioneVoucherListFilter } from '../model/models';
import { TransazioneVoucherSpendForm } from '../model/models';
import { TransazioneVoucherSpendResponseDTO } from '../model/models';
import { TransazioneVoucherStatsDTO } from '../model/models';
import { VoucherArticoloDTO } from '../model/models';
import { VoucherCheckPreviewDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CheckArticoliVoucherTransazionePosRequestParams {
    codice: string;
    idNegozio: string;
}

export interface CheckVoucherTransazionePosRequestParams {
    codice: string;
    idNegozio: string;
}

export interface GetTransazioniPosStatsRequestParams {
    filter: TransazioneVoucherListFilter;
}

export interface ListBandiPosRequestParams {
    idNegozio?: string;
}

export interface ListTransazioniPosRequestParams {
    filter: TransazioneVoucherListFilter;
    pageable: Pageable;
}

export interface SpendArticoliTransazionePosRequestParams {
    transazioneVoucherArticoliBatchForm: TransazioneVoucherArticoliBatchForm;
}

export interface SpendArticoloTransazionePosRequestParams {
    transazioneVoucherArticoloSpendForm: TransazioneVoucherArticoloSpendForm;
}

export interface SpendTransazionePosRequestParams {
    transazioneVoucherSpendForm: TransazioneVoucherSpendForm;
}


export interface EsercenteTransazioniVoucherPOSServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Elenca gli articoli di un voucher cedole (checkarticoli).
     * Risolve il voucher (scope-first anti-IDOR) e ne elenca gli articoli con lo stato corrente (DA_PRENOTARE_O_RITIRARE/PRENOTATO/RITIRATO), senza mutazioni. Voucher CONSUMATO consultabile; ANNULLATO → 422; contributo-mode (nessun articolo) → 422; CF→più voucher → 409. Materializza idempotente i voucher emessi prima della change.
     * @endpoint get /api/v1/esercente/transazioni-voucher/voucher/{codice}/articoli
* @param requestParameters
     */
    checkArticoliVoucherTransazionePos(requestParameters: CheckArticoliVoucherTransazionePosRequestParams, extraHttpRequestParams?: any): Observable<Array<VoucherArticoloDTO>>;

    /**
     * Verifica un voucher pre-spend (preview).
     * Risolve il voucher (per codice, con scope-first anti-IDOR) e verifica lo scope+abilitazione del negozio, ritornando la preview (residuo, intestatario, scadenza, stato) senza mutazioni. Step CHECK del contratto two-phase. 404 fuori insieme/scope; 409 disambiguazione se il CF mappa a più voucher.
     * @endpoint get /api/v1/esercente/transazioni-voucher/voucher/{codice}/check
* @param requestParameters
     */
    checkVoucherTransazionePos(requestParameters: CheckVoucherTransazionePosRequestParams, extraHttpRequestParams?: any): Observable<VoucherCheckPreviewDTO>;

    /**
     * Statistiche incasso del punto vendita.
     * Totale incassato (somma degli incassi: REGOLARE ed ERRATA_CORRIGE, escluse prenotazioni e annullate) + numero transazioni, scopate ai negozi del caller. Filtri opzionali id_negozio (se fuori scope i dati di quel negozio non sono esposti: totali a zero), id_tipo_pratica (bando del voucher) e tipo_transazione, gli stessi della lista: con un tipo che non è un incasso (PRENOTAZIONE, ANNULLATA) i totali sono a zero.
     * @endpoint get /api/v1/esercente/transazioni-voucher/stats
* @param requestParameters
     */
    getTransazioniPosStats(requestParameters: GetTransazioniPosStatsRequestParams, extraHttpRequestParams?: any): Observable<TransazioneVoucherStatsDTO>;

    /**
     * Elenca i bandi su cui si è transato.
     * Bandi dei voucher incassati dai negozi nello scope del caller, per il filtro «Bando» dello storico: il più recente in cima, nessuno escluso per età. Filtro opzionale id_negozio: solo i bandi di quel negozio (fuori scope → lista vuota).
     * @endpoint get /api/v1/esercente/transazioni-voucher/bandi
* @param requestParameters
     */
    listBandiPos(requestParameters: ListBandiPosRequestParams, extraHttpRequestParams?: any): Observable<Array<BandoTransazioniSelectDTO>>;

    /**
     * Elenca i negozi operabili al POS dal caller (scope).
     * Lista piatta dei negozi nello scope del caller (cassiere → negozi assegnati; esercente titolare → negozi posseduti del proprio profilo), ordinati per nome. Serve a popolare il selettore negozio del POS (bootstrap del cassiere nuovo, che non ha ancora transazioni) e quello dello storico. Ogni riga {id, nome, indirizzo, abilitato_ad_almeno_un_bando}: il flag dice se il negozio ha almeno un\&#39;abilitazione formale (domanda ABILITATA, stesso criterio del check, stato del bando escluso); l\&#39;abilitazione per-(bando, negozio) resta verificata al check/spend. Caller senza negozi → [].
     * @endpoint get /api/v1/esercente/transazioni-voucher/negozi
*/
    listNegoziPos(extraHttpRequestParams?: any): Observable<Array<NegozioPosDTO>>;

    /**
     * Elenca le proprie transazioni POS.
     * Page delle transazioni limitate ai negozi nello scope del caller (cassiere/esercente titolare), ordinate per data DESC. Filtri opzionali id_negozio, id_tipo_pratica (bando del voucher) e tipo_transazione: restringono dentro lo scope, mai lo allargano.
     * @endpoint get /api/v1/esercente/transazioni-voucher
* @param requestParameters
     */
    listTransazioniPos(requestParameters: ListTransazioniPosRequestParams, extraHttpRequestParams?: any): Observable<PagedModelTransazioneVoucherListItemDTO>;

    /**
     * Prenota o consegna più articoli in uno scontrino (batch all-or-nothing).
     * Consuma più istanze articolo in un solo scontrino, ciascuna con la propria version. Se anche una sola non è idonea l\&#39;intero scontrino è rifiutato (422) e nulla è persistito (all-or-nothing). Nessun decremento del residuo.
     * @endpoint post /api/v1/esercente/transazioni-voucher/articoli
* @param requestParameters
     */
    spendArticoliTransazionePos(requestParameters: SpendArticoliTransazionePosRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Prenota o consegna un articolo di un voucher cedole.
     * PRENOTAZIONE (istanza → PRENOTATO, transazione a valore 0) o CONSEGNA (istanza → RITIRATO, transazione col valore frozen del libro). Nessun decremento del residuo (chiusura article-driven). Richiede la version dell\&#39;istanza articolo (409 se stale). 404 voucher/articolo fuori scope; 422 negozio non abilitato/articolo già ritirato/contributo-mode/stato.
     * @endpoint post /api/v1/esercente/transazioni-voucher/articolo
* @param requestParameters
     */
    spendArticoloTransazionePos(requestParameters: SpendArticoloTransazionePosRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Consuma importo da un voucher al POS.
     * Crea una transazione REGOLARE, decrementa il residuo del voucher e lo porta a PARZIALMENTE_CONSUMATO (residuo &gt; 0) o CONSUMATO (residuo 0). Richiede la version del voucher (contratto @Version→409 col residuo corrente). 404 voucher fuori insieme/negozio fuori scope; 422 negozio non abilitato/importo/residuo/stato/scadenza; 409 version stale.
     * @endpoint post /api/v1/esercente/transazioni-voucher
* @param requestParameters
     */
    spendTransazionePos(requestParameters: SpendTransazionePosRequestParams, extraHttpRequestParams?: any): Observable<TransazioneVoucherSpendResponseDTO>;

}
